import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import LeftMenu from '../component/LeftMenu';
import Header from '../component/Header';

const MainLayout = () => {
    return (
        <>
            <Wrap>
                <LeftMenu/>
                <CntArea>
                    <Header/>
                    <CntBox>
                        <Outlet/>
                    </CntBox>
                </CntArea>
            </Wrap>
        </>
    );
}   

export default MainLayout;

const Wrap = styled.div`
    width: 100%;
    display: flex;
`

const CntArea = styled.div`
    width: calc(100% - 280px);;
`

const CntBox = styled.div`
    width: 100%;
    min-height: calc(100vh - 80px);
    padding: 20px 28px;
    box-sizing: border-box;
    background-color: #fafafa;

    > h1 {
        font-size: 22px;
        font-weight: 700;
        color: #111;
        margin-bottom: 20px;
    }
`